import { useEffect, useState } from "react";
import { Virtual } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { Product } from "../../../../models/home-rows";
import { _c } from "../../../../services/text-services";
import AppRecommandedProduct from "../recommanded-product/recommanded-product.component";
// @ts-ignore 
import styles from "./feature-list.component.module.scss";

const TRANSITION_SPEED = 200; // miliseconds
interface AppFeatureListProps {
  productsArray: Product[];
  title: string;
}

function AppFeatureList({ productsArray, title }: AppFeatureListProps) {
  const [theSwiper, setTheSwiper] = useState<any>();
  const [navIsBeginning, setNavIsBeginning] = useState(true);
  const [navIsEnd, setNavIsEnd] = useState(true);
  useEffect(() => { 
    if (!theSwiper) return;
    theSwiper.update();
    setNavIsBeginning(theSwiper.activeIndex < 1);
    setNavIsEnd(theSwiper.isEnd);
  }, [theSwiper]);

  return <Swiper

    modules={[Virtual]}
    virtual
    autoHeight={false}
    className={_c(styles, "recommanded-wrapper d-flex")}
    onAfterInit={(swiper) => setTheSwiper(swiper)}
    onActiveIndexChange={(swiper) => {
      //console.log("swiper.isBeginning", swiper.isBeginning);
      //console.log("swiper.isEnd", swiper.isEnd);
      //console.log("swiper.activeIndex", swiper.activeIndex);
      //console.log("swiper", swiper);
      setNavIsBeginning(swiper.activeIndex < 1);
      setNavIsEnd(swiper.isEnd);
    }}
    breakpoints={{
      1450: {
        slidesPerView: 4,
        spaceBetween: 15,
      },

      1350: {
        slidesPerView: 4,
        spaceBetween: 15,
      },      
      1200: {
        slidesPerView: 3,
        spaceBetween: 15,
      },

      768: {
        slidesPerView: 3,
        spaceBetween: 15,
      },

      600: {
        slidesPerView: 3,
        spaceBetween: 15,
      },

      400: {
        slidesPerView: 2,
        spaceBetween: 15,
      },

      300: {
        slidesPerView: 1,
        spaceBetween: 15,
      }   
      
      
    }}
  >
    {productsArray.map((product, index) => (
      <div
        key={product.id}
        className={_c(styles, "col-lg-3 col-6 mt-2 mb-4 slideItem")}
      >
        <div className="px-1">
          {/* <FeatureItem product={prod as Product} /> */}
          <SwiperSlide
            key={`prod-${index}`}
            virtualIndex={index}
          ><AppRecommandedProduct product={product as Product} title={title}/></SwiperSlide>
        </div>
      </div>
    ))}
      {!navIsEnd &&<div onClick={() => theSwiper.slideNext(TRANSITION_SPEED, false)} className={_c(styles, "next-recommanded nav")}>›</div>}
      {!navIsBeginning && <div onClick={() => theSwiper.slidePrev(TRANSITION_SPEED, false)} className={_c(styles, "prev-recommanded nav")}>‹</div>}      
  </Swiper>;
}
export default AppFeatureList;
